import React, { useEffect, useState } from 'react';
import { JSON_ONE } from "./JSON_DATA_Request";
import { JSON_ONE1 } from "./JSON_DATA_Response";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import ResponseJSON from './ResponseJSON';
import RequestJSON from './RequestJSON';
function ValidateVPAAPI() {
const [ShowHideAccordion, SetShowHideAccordion] = useState(false);
const [ShowHideAccordionTwo, SetShowHideAccordionTwo] = useState(false);
const [ShowHideAccordionThree, SetShowHideAccordionThree] = useState(false);
const onClickAccordianShowHide = () => {
SetShowHideAccordion(!ShowHideAccordion)
}
const onClickAccordianShowHideTwo = () => {
SetShowHideAccordionTwo(!ShowHideAccordionTwo)
}
const onClickAccordianShowHideThree = () => {
SetShowHideAccordionThree(!ShowHideAccordionThree)
}
const [TabCheck1, SetTabCheck1] = useState(false)
const [TabCheck2, SetTabCheck2] = useState(false)
const onClickCangeTab1 = () => {
SetTabCheck1(!TabCheck1);
}
const onClickCangeTab2 = () => {
SetTabCheck2(!TabCheck2);
}
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_layout1">
               <h1> Validate VPA API</h1>
               <hr/>
            </section>
         </div>
         <div class="col-md-4 extreme-rt-div">
         </div>
      </div>
      <div class="row">
         <div class="col-md-8 mt-60">
            <h2>Validate VPA API</h2>
            <p>
               UPI ID also called Virtual Payment Address or VPA is a unique ID you need to create in order to send and accept money via UPI. Once a UPI address is created and mapped against your existing bank account, you can simply share your UPI address (eg. abc@okaxis) to send and receive the payments.
            </p>
            <p>
               Safexpay Validate VPA API will check and provide if the UPI ID is valid and show the name of the account holder. You can avail yourself of this feature by simply submitting the API request to Safexpay, and we will give an instant response. An API will be integrated with your internal system to automate verification.
            </p>
            <p>
               API Request: Below are the API details that you must integrate on your system
            </p>
            <p>
               {/* <b>Posting URL:</b> <span class="col-red">https://www.avantgardepayments.com/agcore/validatesVPA</span>  */}  
               <b>Posting URL :</b> <span class="col-red">https://checkout.safexpay.com/agcore/validatesVPA</span>                     
            </p>
            <p>
               Request: (All the parameters in the API request are mandatory)
            </p>
            <h5>Sample Request</h5>
            <p>
               201705240001|5akU+PET8bFaJZ3uKmuSLfEgIJNpiwkbkBeGFob7XpHYADJE1sMNlim8JPSEon<br></br>Zav5dSz DsW5W+Tu8jbqD6dpQ35kM3WMy746Egxloa3YSBcQzNPeR/8c30HK9R9AFwNDj4yyj2UdRQ/<br></br>LS67wEvnhQ==
            </p>
            <h5>Sample Response</h5>
            <div class="form-data">
               "status": "Valid UPI ID"<br></br>
               "custVPA": "6588764738@ybl"<br></br>
               "payerName": "Jhon Disouza"<br></br>
               "merchantId": "201705240001"<br></br>
               "orderNo": "4354554"
            </div>
            <u>
               <p>
                  AUTHORIZATIONS:
               </p>
            </u>
            <p className="mb-0">REQUEST BODY SCHEMA: &nbsp;<span style={{ color: "#313131" }}>application/json</span></p>
            <hr class="hr-col">
            </hr>
            <table class="sc-hHEiqL iZJLLY">
               <tbody>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="meId">
                        <span class="sc-iemWCZ fhDkLh"></span><span>meId</span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                              <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pgId">
                        <span class="sc-iemWCZ fhDkLh"></span><span>pgId</span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div>
                              <span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="orderNum"><span class="sc-iemWCZ fhDkLh"></span>
                        <span>orderNum</span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                              <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr class="last undefined">
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="custVPA">
                        <span class="sc-iemWCZ fhDkLh"></span><span>custVPA</span>
                     </td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string
                              </span>
                           </div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                           </div>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </table>
            <h5 className="mt-30">Responses</h5>
            <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
               <div class="card">
                  <div class="card-header" id="heading1">
                     <h5 class="mb-0">
                        <div style={{ backgroundColor: "rgba(29, 129, 39, 0.07)", color: "rgb(29, 129, 39)", padding: "10px 15px" }} onClick={onClickCangeTab1}>
                        <b>200</b> Encrypted Response Format  {TabCheck1 ?
                        <FaAngleUp />
                        :
                        <FaAngleDown />
                        }
                  </div>
                  </h5>
               </div>
               {
               TabCheck1 &&
               <div>
                  <div class="card-body">
                     <p className="mb-0">RESPONSE SCHEMA: &nbsp;<span style={{ color: "#313131" }}>application/json</span></p>
                     <hr class="hr-col">
                     </hr>
                     <table class="sc-hHEiqL iZJLLY">
                        <tbody>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span class="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>Valid UPI ID</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="custVPA"><span class="sc-iemWCZ fhDkLh"></span><span>custVPA</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>timishbenday@okhdfcbank</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="payerName"><span class="sc-iemWCZ fhDkLh"></span><span>payerName</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>TIMISH BENDAY</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr>
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="orderNo"><span class="sc-iemWCZ fhDkLh"></span><span>orderNo</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>050506565_test</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                           <tr class="last undefined">
                              <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="merchantId"><span class="sc-iemWCZ fhDkLh"></span><span>merchantId</span></td>
                              <td class="sc-bkbkJK gmOLLi">
                                 <div>
                                    <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                    <div>
                                       <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                          <p>201910300123</p>
                                       </div>
                                    </div>
                                 </div>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
               }
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>400 Bad request</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>401 Unauthorized</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>403 forbidden</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>404 Not found</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>500 server-error</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span>503 service-unavailable</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header" id="heading1">
                  <h5 class="mb-0">
                     <div style={{ backgroundColor: "rgb(252 239 239)", color: "rgb(212, 31, 28)", padding: "10px 15px" }} onClick={onClickCangeTab2}>
                     <b>default</b> Succesfull Transaction  {TabCheck2 ?
                     <FaAngleUp />
                     :
                     <FaAngleDown />
                     }
               </div>
               </h5>
            </div>
            {
            TabCheck2 &&
            <div>
               <div class="card-body">
                  <p className="mb-0">RESPONSE SCHEMA: &nbsp;<span style={{ color: "#313131" }}>Application/x-www-form-urlencode</span></p>
                  <hr class="hr-col">
                  </hr>
                  <table class="sc-hHEiqL iZJLLY">
                     <tbody>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span class="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 10 </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Aggregator ID.It's value must be AvantGarde</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Merchant Id issued by Avantgrade</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="order_no"><span class="sc-iemWCZ fhDkLh"></span><span>order_no</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>This is your Transaction ID for which you have initiated payment.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="amount"><span class="sc-iemWCZ fhDkLh"></span><span>amount</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">number</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;double&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>This is your Transaction Amount.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Country"><span class="sc-iemWCZ fhDkLh"></span><span>Country</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span class="sc-fbIWvP sc-jOFryr JIFSj egeLzW col-green">^\d{3}$</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>ISO Country Code.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Currency"><span class="sc-iemWCZ fhDkLh"></span><span>Currency</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span class="sc-fbIWvP sc-jOFryr JIFSj egeLzW col-green">^\d{3}$</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>ISO Currency Code.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_date"><span class="sc-iemWCZ fhDkLh"></span><span>txn_date</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> 10 characters </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>The transaction date and must be supplied in DD-MM-YY format.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_time"><span class="sc-iemWCZ fhDkLh"></span><span>txn_time</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> 8 characters </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>The transaction time and must be supplied in HH:MM:SS format.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_ref"><span class="sc-iemWCZ fhDkLh"></span><span>ag_ref</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>This is Transaction ID generated by aggregator for which you have initiated payment.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_ref"><span class="sc-iemWCZ fhDkLh"></span><span>pg_ref</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>This is Transaction ID generated by gateway for which you have initiated payment.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span class="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Successful"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Failed"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Holding"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Pending"</span> </div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Transaction Status </p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_code"><span class="sc-iemWCZ fhDkLh"></span><span>res_code</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 5 ] </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Response Code. "0" for Success</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_message"><span class="sc-iemWCZ fhDkLh"></span><span>res_message</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 200 ] </span></span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Response message explaining the failure reason. "0" for Success</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr className='expanded'>
                           <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHide}>
                              <span className='sc-iemWCZ fhDkLh'></span>
                              <span>
                                 pg_details {ShowHideAccordion ? 
                                 <FaAngleDown/>
                                 : 
                                 <FaAngleUp/>
                                 }
                              </span>
                           </td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                    <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                                 </div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        {ShowHideAccordion &&
                        <tr>
                           <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                              <div className="sc-dIvrsQ kPKTxr">
                                 <table class="sc-hHEiqL iZJLLY">
                                    <tbody>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="senderKey"><span class="sc-iemWCZ fhDkLh"></span><span>senderKey</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;base64&gt; </span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>public key identifying the sender of the payload</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_id"><span class="sc-iemWCZ fhDkLh"></span><span>pg_id</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;int64&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 3 ] </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Bank Number. E.g. “1” for HDFC Bank</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_name"><span class="sc-iemWCZ fhDkLh"></span><span>pg_name</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 50 ] </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Bank Name</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymode"><span class="sc-iemWCZ fhDkLh"></span><span>paymode</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"NB"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"CC"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"DC"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"PP"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"WA"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"CE"</span> </div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Provides details about the paymode.<br/>
                                                         Valid values:<br/>
                                                      </p>
                                                      <ul>
                                                         <li>NB: Net Banking</li>
                                                         <li>CC: Credit Card</li>
                                                         <li>DC: Debit Card</li>
                                                         <li>PP: Prepaid Card</li>
                                                         <li>WA: Wallet</li>
                                                         <li>CE: Credit Card EMI</li>
                                                      </ul>
                                                      <p></p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr class="last undefined">
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="emi_months"><span class="sc-iemWCZ fhDkLh"></span><span>emi_months</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span></div>
                                                <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"3"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"6"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"9"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"12"</span> </div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Tenure of EMI (3/6/9/12).Paymode must be Credit Card EMI (CCE).</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                    </tbody>
                                 </table>
                              </div>
                           </td>
                        </tr>
                        }
                        <tr className='expanded'>
                           <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideTwo}>
                              <span className='sc-iemWCZ fhDkLh'></span>
                              <span>
                                 fraud_details {ShowHideAccordionTwo ? 
                                 <FaAngleDown/>
                                 : 
                                 <FaAngleUp/>
                                 }
                              </span>
                           </td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                    <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                                 </div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        {ShowHideAccordionTwo &&
                        <tr>
                           <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                              <div className="sc-dIvrsQ kPKTxr">
                                 <table class="sc-hHEiqL iZJLLY">
                                    <tbody>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_action"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_action</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Accept"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Reject"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Review"</span> </div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Provides details about the fraud action. <br/>
                                                         Only if fraud engine is selected <br/>
                                                         Valid values:<br/>
                                                      </p>
                                                      <ul>
                                                         <li>Accept: Fraud not suspected. </li>
                                                         <li>Reject: Very strong fraud suspicion, reject the order. </li>
                                                         <li>Review:  Fraud suspected, review the customer details before processing the order. </li>
                                                      </ul>
                                                      <p></p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_message"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_message</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 200 </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Fraud message describes the fraud in details.Only if fraud engine is selected.</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr class="last undefined">
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="score"><span class="sc-iemWCZ fhDkLh"></span><span>score</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;int64&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>Risk scale</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                    </tbody>
                                 </table>
                              </div>
                           </td>
                        </tr>
                        }
                        <tr className='expanded last undefined'>
                           <td class="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field" title="header" onClick={onClickAccordianShowHideThree}>
                              <span className='sc-iemWCZ fhDkLh'></span>
                              <span>
                                 other_details {ShowHideAccordionThree ? 
                                 <FaAngleDown/>
                                 : 
                                 <FaAngleUp/>
                                 }
                              </span>
                           </td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span>
                                    <span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span>
                                 </div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        {ShowHideAccordionThree &&
                        <tr className='expanded'>
                           <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                              <div className="sc-dIvrsQ kPKTxr">
                                 <table class="sc-hHEiqL iZJLLY">
                                    <tbody>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf1"><span class="sc-iemWCZ fhDkLh"></span><span>udf1</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>user defined field that you can use to send any additional information about the transaction</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf2"><span class="sc-iemWCZ fhDkLh"></span><span>udf2</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>user defined field that you can use to send any additional information about the transaction</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf3"><span class="sc-iemWCZ fhDkLh"></span><span>udf3</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>user defined field that you can use to send any additional information about the transaction</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr>
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf4"><span class="sc-iemWCZ fhDkLh"></span><span>udf4</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>user defined field that you can use to send any additional information about the transaction</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                       <tr class="last undefined">
                                          <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf5"><span class="sc-iemWCZ fhDkLh"></span><span>udf5</span></td>
                                          <td class="sc-bkbkJK gmOLLi">
                                             <div>
                                                <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div>
                                                <div>
                                                   <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                      <p>user defined field that you can use to send any additional information about the transaction</p>
                                                   </div>
                                                </div>
                                             </div>
                                          </td>
                                       </tr>
                                    </tbody>
                                 </table>
                              </div>
                           </td>
                        </tr>
                        }
                     </tbody>
                  </table>
               </div>
            </div>
            }
         </div>
      </div>
   </div>
   <div class="col-md-4 extreme-rt-div">
      <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
         <div class="card">
            <div class="card-header" id="heading1">
               <h5 class="mb-0">
                  <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab1}>
                  <button> POST </button> /agcore/validatesVPA  {TabCheck1 ?
                  <FaAngleUp />
                  :
                  <FaAngleDown />
                  }
            </div>
            </h5>
         </div>
         {
         TabCheck1 &&
         <div>
            <br />
            <div class="card-body">
               <p class="mb-0">Production server (uses live data)</p>
               <div class="api-div-bor">
                  <span>https://www.avantgardepayments.com</span><span
                     class="col-org">/agcore/validatesVPA</span>
               </div>
               <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
               <div class="api-div-bor">
                  <span>https://pguat.safexpay.com</span><span
                     class="col-org">/agcore/validatesVPA</span>
               </div>
            </div>
         </div>
         }
      </div>
   </div>
   <RequestJSON/>
   <ResponseJSON/>
</div>
</div>
</div>
</div>
)
}
export default ValidateVPAAPI